var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSpatialData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 19.5h-12a3 3 0 01-3-3C4.486 15.093 5.579 15 6 15c.421 0 .932-.065 1.409.608.695.98-.494 2.392-.494 2.392 1.686-1 2.086-2.381 2.093-3.937.001-.254-.002-3.327-.005-5.563H19.5v11zm-15-11V6c0-.827.673-1.5 1.5-1.5l.083.002c.781.041 1.417.789 1.417 1.67L7.501 7l.002 1.5.006 5.349C7.133 13.646 6.64 13.5 6 13.5c-.526 0-1.031.091-1.5.257V8.5zM20 7H9.001L9 6.17c0-1.386-.889-2.642-2.157-3.036-.051-.015-.1-.032-.153-.045a2.585 2.585 0 00-.345-.055c-.062-.008-.12-.026-.184-.03a2.977 2.977 0 00-.755.056c-.065.013-.124.039-.187.056-.125.033-.25.065-.367.114-.072.029-.135.071-.204.105-.101.052-.204.101-.298.163-.069.045-.128.1-.192.15-.084.066-.171.13-.248.205-.06.058-.11.125-.165.188-.069.079-.14.156-.2.242-.049.071-.088.146-.131.22-.052.09-.106.179-.149.275-.036.079-.06.163-.089.246-.034.1-.07.198-.093.301-.02.088-.03.177-.042.267C3.022 5.727 3 5.86 3 6v10.5A4.5 4.5 0 007.5 21H21V7h-1z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpatialData);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconSpatialData.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };